module.exports = __webpack_public_path__ + "img/institution_placehold.c003a2b7.png";